export const ACCESS_MODE_KEY = "venaqqi_access_mode";

export const ACCESS_MODES = Object.freeze({
  PENDING: "pending",
  GUEST: "guest",
  AUTHENTICATED: "authenticated",
});

export const readPersistedAccessMode = (storage = window.localStorage) =>
  storage.getItem(ACCESS_MODE_KEY) === ACCESS_MODES.GUEST
    ? ACCESS_MODES.GUEST
    : ACCESS_MODES.PENDING;

export const persistAccessMode = (mode, storage = window.localStorage) => {
  if (mode === ACCESS_MODES.GUEST) storage.setItem(ACCESS_MODE_KEY, mode);
  else storage.removeItem(ACCESS_MODE_KEY);
};

